import { DefaultSidebar } from "@excalidraw/excalidraw";

// FLF Draw: barra lateral padrao (biblioteca de formas), sem as abas de propaganda do Excalidraw+.
export const AppSidebar = () => {
  return <DefaultSidebar />;
};
